import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceDetectService {

  constructor() {
  }

  detectBrowser() {
    const ua = window.navigator.userAgent;
    let device;
    let browser;
    let data = {};

    // get device
    if (ua.match(/(iPhone)/)) {
      device = 'iPhone';
    } else if (ua.match(/(iPad)/)) {
      device = 'iPad';
    } else if (ua.match(/(iPod)/)) {
      device = 'iPod';
    } else if (ua.match(/(BlackBerry|BB10)/)) {
      device = 'BlackBerry';
    } else if (ua.match(/(IEMobile)/)) {
      device = 'WindowsMobile';
    } else if (ua.match(/(Android)/)) {
      device = 'Android';
    } else if (ua.match(/(Macintosh)/)) {
      device = 'Macintosh';
    } else if (ua.match(/(Windows)/)) {
      device = 'Windows';
    } else if (ua.match(/(Linux)/)) {
      device = 'Linux';
    } else if (ua.match(/(Opera Mini)/)) {
      device = 'OperaMini';
    } else if (ua.match(/(Mobi)/)) {
      device = 'Mobi';
    } else if (ua.match(/(IEMobi)/)) {
      device = 'Mobi';
    }

    // get browser
    if (ua.indexOf('OPR') > 0 || ua.indexOf('Opera') > 0) {
      browser = 'Opera';
    } else if (ua.indexOf('Chrome') > 0 && ua.indexOf('Edge') === -1) {
      browser = 'Chrome';
    } else if (ua.indexOf('Firefox') > 0) {
      browser = 'Firefox';
    } else if (ua.indexOf('Safari') > 0 && ua.indexOf('Edge') === -1) {
      browser = 'Safari';
    } else if (ua.indexOf('MSIE') > 0) {
      browser = 'IE';
    } else if (ua.indexOf('Edge') > 0) {
      browser = 'Edge';
    }

    // create object
    data = {
      device:  device,
      browser: browser
    };
    return data;
  }

  detectMobile() {
    const toMatch = [
      /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];
    return toMatch.some((toMatchItem) => {
      return window.navigator.userAgent.match(toMatchItem);
    });
  }
}
